import { useAppContext } from "../context";

interface IButton {
    onClick: () => void;
    disabled?: boolean;
    text: string;
    type?: 'green' | 'grey' | 'white' | 'red';
    className?: string;
}

const typeClasses = {
    green: 'bg-vkusvill-green text-white hover:bg-vkusvill-green/90 ',
    grey: 'bg-cgrey text-white hover:bg-cgrey/90',
    white: 'bg-white text-vkusvill-green hover:bg-white/90 ',
    red: ' bg-cred text-white hover:bg-cred/90'
}

export const Button = ({
    onClick,
    disabled,
    text,
    type = 'green',
    className
}: IButton) => {
    const { isMobile } = useAppContext();

    return (
        <button
            className={`w-full rounded-lg transition-colors text-xl/5 ${typeClasses[type]} ${className} ${isMobile ? 'h-[52px]' : 'h-[46px]'}`}
            onClick={onClick}
            disabled={disabled}
        >
            {text}
        </button>
    )
}